module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAMCAYAAAC5tzfZAAAAcUlEQVQokWP0nPCLAQtgYmBgOM/AwPCYgYHBB12aBZsOBgYGXgYGBj0GBgZ5XCaSDOirCYQvMjAw/EfCH6Dy/GjiILyFLOeBQu8fAwODPpo4yAaQbR8ZGBgEsDmPLD/RRxOuFPGZgYHhEjQZoQIGBgYAHNUTn3ncwvUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/add.png
// module id = L3SC
// module chunks = 1